// Strapi URL
export var strapiURL = "https://strapi-jari.ey.r.appspot.com";
export var wpURL = "https://wp.jari-claes.ch/wp-json/wp/v2/";
export var en_wpURL = "https://wp.jari-claes.ch/en/wp-json/wp/v2/";
